export function normalizeSelectionValue(value: unknown): string {
  return value === null || value === undefined ? '' : String(value);
}

export function normalizeSelectionArray(values: unknown): string[] {
  return Array.isArray(values) ? values.map(normalizeSelectionValue).filter(value => value !== '') : [];
}
